module.exports = __webpack_public_path__ + "img/circle.cae9db89.svg";